import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'modules/main/redux';
import { downloadBlobFile } from 'modules/downloads';
import { NotificationTypes } from 'modules/notifications';
import { addNotification } from 'modules/notifications/redux';

import { RoutingFilesApi } from '../api';
import { downloadedRoutingByIdSelector } from '../redux/selectors';

const sanitizeFilenamePart = (value: string): string =>
  value.trim().replace(/[^a-zA-Z0-9-_]+/g, '_');

export const useDownloadRoutingCsv = (
  id: string,
): {
  handleDownloadCsv: () => Promise<void>;
  csvDownloading: boolean;
} => {
  const dispatch = useDispatch();
  const isRoutingV2 = true;
  const [csvDownloading, setCsvDownloading] = useState(false);
  const routing = useSelector((state: RootState) =>
    downloadedRoutingByIdSelector(state, id),
  );
  const handleDownloadCsv = useCallback(async () => {
    try {
      setCsvDownloading(true);
      const { blob } = isRoutingV2
        ? await RoutingFilesApi.downloadRoutingCsvV2(id)
        : await RoutingFilesApi.downloadRoutingCsv(id);
      const routingName =
        routing?.metadata?.Internal?.routingName || `Route_${id}`;
      const routingModel = routing?.metadata?.Meteo?.Model || '';
      const modelRun = routing?.metadata?.Internal?.modelRun || '';
      const filename = [
        'Dorado',
        sanitizeFilenamePart(routingName),
        sanitizeFilenamePart(routingModel),
        sanitizeFilenamePart(modelRun),
      ]
        .filter(Boolean)
        .join('_');
      downloadBlobFile(blob, `${filename}.csv`);
    } catch (error) {
      dispatch(
        addNotification({
          type: NotificationTypes.Error,
          message: `Error while exporting routing into CSV`,
        }),
      );
    } finally {
      setCsvDownloading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, isRoutingV2, routing]);
  return {
    handleDownloadCsv,
    csvDownloading,
  };
};
